import { RocheUIStoryType as r } from "../../types/roche-story-type.js";
var a = /* @__PURE__ */ ((t) => (t.VARIANT_A = "story-teaser--variant-a", t.VARIANT_B = "story-teaser--variant-b", t.VARIANT_C = "story-teaser--variant-c", t))(a || {});
const A = {
  [r.DEFAULT]: null,
  [r.PODCAST]: "podcasts",
  [r.SERIES]: "series",
  [r.SLIDESHOW]: "book",
  [r.VIDEO]: "play"
};
export {
  A as RocheUIIconVariant,
  a as RocheUIStoryTeaserLayout
};
